import { create } from '@storybook/theming/create';

export default create({
  base: 'light',
  brandTitle: 'Icons',
  brandUrl: 'https://64608cd233178793bb0ce2f6-qtsknljibb.chromatic.com',
  brandImage: './logo.png',
  brandTarget: '_self',
});
